export default __webpack_public_path__ + "static/media/avatar-6.dc44eabf.jpg";